import BaseButton from "./BaseButton";
import { useTranslation } from "react-i18next";

type Category = "all" | "classroom" | "faculty" | "other";
const CATEGORY_LABELS: Record<Category, string> = {
  all: "すべて",
  classroom: "講義室",
  faculty: "教員室",
  other: "その他",
};
const CATEGORIES: Category[] = ["all", "classroom", "faculty", "other"];

/**
 * CategorySelector が受け取る Props
 */
interface CategorySelectorProps {
  selectedCategory: Category;
  onSelectCategory: (category: Category) => void;
  // counts: 件数が0のときボタンを無効化するために利用
  counts?: Record<Category, number>;
}

export const CategorySelector = ({
  selectedCategory,
  onSelectCategory,
  counts,
}: CategorySelectorProps) => {
  const handleCategoryClick = (category: Category) => {
    onSelectCategory(category);
  };
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-row gap-2 items-center">
      {CATEGORIES.map((cat) => (
        <BaseButton
          key={cat}
          isSelected={selectedCategory === cat}
          onClick={() => handleCategoryClick(cat)}
          disabled={counts ? counts[cat] === 0 : false}
          className="flex-1 justify-center px-2"
        >
          {t(CATEGORY_LABELS[cat])}
        </BaseButton>
      ))}
    </div>
  );
};

export default CategorySelector;
